"use client";

import React, { useState } from "react";
import Link from "next/link";
import { X, Send } from "lucide-react";
import { Icon } from "@iconify/react";

export default function WhatsApp() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  const phoneNumber = "9856008848"; // Infinity Adventure WhatsApp
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=Hello!%20I%20have%20an%20inquiry%20about%20Infinity%20Adventure%20Nepal.`;

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!hasOpened) setHasOpened(true);
  };

  return (
    <div className="fixed bottom-12 right-10 z-[9999] flex flex-col items-end gap-3 pointer-events-auto">
      {/* WhatsApp Popup Card */}
      {isOpen && (
        <div className="w-80 sm:w-96 bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 ease-in-out animate-in fade-in slide-in-from-bottom-5">
          {/* Header */}
          <div className="bg-emerald-600 p-4 text-white flex items-center justify-between relative">
            <div className="flex items-center gap-3">
              <div className="relative">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white font-bold text-lg">
                  <Icon icon="logos:whatsapp-icon" className="w-7 h-7" />
                </div>
                <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 rounded-full animate-pulse"></span>
              </div>
              <div>
                <h4 className="font-semibold text-sm leading-tight text-white">
                  Infinity Adventure Nepal
                </h4>
                <p className="text-xs text-emerald-100 flex items-center gap-1 mt-0.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-green-400 inline-block"></span>
                  Typically replies instantly
                </p>
              </div>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white/80 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors"
              aria-label="Close WhatsApp window"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Body / Chat Area */}
          <div className="p-4 bg-emerald-50/40 min-h-[140px] flex flex-col justify-between gap-3 text-zinc-800">
            <div className="bg-white p-3.5 rounded-2xl rounded-tl-none shadow-sm max-w-[92%] text-xs sm:text-sm text-zinc-700 leading-relaxed">
              <p className="font-medium text-emerald-800 mb-1">
                Namaste! 🙏
              </p>
              <p>
                Welcome to Infinity Adventure Nepal. How can we help you plan your trekking or mountaineering trip today?
              </p>
              <span className="text-[10px] text-zinc-400 block text-right mt-1">
                Just now
              </span>
            </div>

            {/* Action Button */}
            <Link
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-emerald-500 hover:bg-emerald-600 active:bg-emerald-700 text-white font-medium text-sm py-2.5 px-4 rounded-xl flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all group"
            >
              <Icon icon="logos:whatsapp-icon" className="w-5 h-5" />
              <span>Start Chat on WhatsApp</span>
              <Send className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Footer note */}
          <div className="px-4 py-2 bg-zinc-50 text-[10px] text-center text-zinc-400">
            Powered by WhatsApp Direct
          </div>
        </div>
      )}

      {/* Floating Toggle Button */}
      <div className="relative group">
        {/* Tooltip on hover when closed */}
        {!isOpen && (
          <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 hidden sm:block opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap bg-zinc-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg shadow-lg">
            Need Help? Chat on WhatsApp
          </div>
        )}

        {/* Pulse ring animation */}
        <span className="absolute -inset-1 rounded-full bg-emerald-500/40 animate-ping opacity-75 pointer-events-none"></span>

        <button
          onClick={handleToggle}
          className="relative flex items-center justify-center w-14 h-14 bg-emerald-500 hover:bg-emerald-600 active:scale-95 text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 group focus:outline-none"
          aria-label="Chat on WhatsApp"
        >
          {isOpen ? (
            <X className="w-7 h-7 text-white transition-transform duration-300 rotate-0 hover:rotate-90" />
          ) : (
            <>
              <Icon icon="logos:whatsapp-icon" className="w-8 h-8" />
              {/* Unread notification badge */}
              {!hasOpened && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-bounce">
                  1
                </span>
              )}
            </>
          )}
        </button>
      </div>
    </div>
  );
}
